"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ControlContainer;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./unstyledControlContainer.css");

function ControlContainer(props) {
  return _react.default.createElement("div", {
    className: "unstyled_control_container ".concat(props.disabled ? 'unstyled_control_container_disabled' : '', " ").concat(props.className)
  }, props.children);
}

ControlContainer.propTypes = {
  disabled: _propTypes.default.bool,
  className: _propTypes.default.string,
  children: _propTypes.default.node
};